import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "edit-orientation"
}
const _hoisted_2 = { class: "samples" }
const _hoisted_3 = {
  key: 0,
  class: "sample more"
}

import { computed, ref } from 'vue';

import { t } from '@services/l10n';
import * as utils from '@services/utils/common';

import NcActions from '@nextcloud/vue/components/NcActions';
import NcActionButton from '@nextcloud/vue/components/NcActionButton';

import RotateLeftIcon from 'vue-material-design-icons/RotateLeft.vue';
import RotateRightIcon from 'vue-material-design-icons/RotateRight.vue';
import FlipHorizontalIcon from 'vue-material-design-icons/FlipHorizontal.vue';
import XImg from '@components/frame/XImg.vue';

import type { IPhoto } from '@typings';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditOrientation',
  props: {
    photos: {},
    disabled: { type: Boolean }
  },
  emits: ["save"],
  setup(__props: any, { expose: __expose }) {

const NORMAL = [1, 6, 3, 8];
const FLIPPED = [2, 7, 4, 5];

const props = __props;



/** Current state relative to 1 */
const state = ref(1);
/** Full (360) rotations for CSS transition */
const spins = ref(0);

const samples = computed(() => props.photos.slice(0, 8).map((photo) => utils.getPreviewUrl({ photo, size: 512 })));

const transform = computed(() => {
  const f = isflip(state.value) ? -1 : 1;
  const d = spins.value;
  return `${transform1.value} rotate(${d * 360 * f}deg)`;
});

const transform1 = computed((): string => {
  if (props.disabled) return String();

  /**
   * 1 = Horizontal (normal)
   * 2 = Mirror horizontal
   * 3 = Rotate 180
   * 4 = Mirror vertical
   * 5 = Mirror horizontal and rotate 270 CW
   * 6 = Rotate 90 CW
   * 7 = Mirror horizontal and rotate 90 CW
   * 8 = Rotate 270 CW
   */
  if (state.value < 1 || state.value > 8) {
    console.error('Invalid orientation state', state.value);
    return String();
  }

  switch (state.value) {
    case 1:
      return 'rotate(0deg)';
    case 2:
      return 'scaleX(-1)';
    case 3:
      return 'rotate(180deg)';
    case 4:
      return 'scaleX(-1) rotate(-180deg)';
    case 5:
      return 'scaleX(-1) rotate(-270deg)';
    case 6:
      return 'rotate(90deg)';
    case 7:
      return 'scaleX(-1) rotate(-90deg)';
    case 8:
      return 'rotate(270deg)';
  }

  return String();
});

/** Reset state to initial */
function reset() {
  state.value = 1;
  spins.value = 0;
}

/**
 * Get target orientation state for a photo.
 * If no change is needed, return null.
 */
function result(photo: IPhoto): number | null {
  const exif = photo.imageInfo?.exif;
  if (!exif) return null;

  let target = Number(exif.Orientation) || 1;
  const oldState = target;

  // Check if state is valid
  if (target < 1 || target > 8) {
    target = 1;
  }

  // Flip state if needed
  if (isflip(state.value)) {
    target = flip(target);
  }

  // Rotate state by index difference
  const cindex = list(state.value).indexOf(state.value);
  const targetList = list(target);
  const sindex = targetList.indexOf(target);
  target = targetList[(cindex + sindex) % targetList.length];

  // No change
  if ((!exif.Orientation && target === 1) || target === oldState) {
    return null;
  }

  return target;
}

function doleft() {
  const current = list(state.value);
  let index = current.indexOf(state.value) - 1;
  if (index < 0) {
    spins.value--;
    index = current.length - 1;
  }
  state.value = current[index];
}

function doright() {
  const current = list(state.value);
  let index = current.indexOf(state.value) + 1;
  if (index === current.length) {
    spins.value++;
    index = 0;
  }
  state.value = current[index];
}

function doflip() {
  state.value = flip(state.value);
}

/** Flip a state in-place */
function flip(flipState: number) {
  if (isflip(flipState)) {
    let i = FLIPPED.indexOf(flipState);
    if (i === 1) i = 3;
    else if (i === 3) i = 1;
    return NORMAL[i];
  } else {
    let i = NORMAL.indexOf(flipState);
    if (i === 1) i = 3;
    else if (i === 3) i = 1;
    return FLIPPED[i];
  }
}

/** Check if a state is flipped */
function isflip(checkState: number) {
  return FLIPPED.includes(checkState);
}

/** Get rotation list for this state (flipped / regular) */
function list(listState: number) {
  return isflip(listState) ? FLIPPED : NORMAL;
}

__expose({ reset, result });

return (_ctx: any,_cache: any) => {
  return (samples.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_unref(t)(
        'memories',
        'This feature rotates images losslessly by updating the EXIF metadata. This approach is known to sometimes not work correctly on certain image types such as HEIC. Make sure you do a test run before using it on multiple images.',
      )) + " ", 1),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samples.value, (src) => {
            return (_openBlock(), _createBlock(XImg, {
              class: "sample",
              key: src,
              src: src,
              style: _normalizeStyle({ transform: transform.value })
            }, null, 8, ["src", "style"]))
          }), 128)),
          (__props.photos.length > samples.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", null, "+" + _toDisplayString(__props.photos.length - samples.value.length), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(NcActions), {
          inline: 3,
          class: "actions"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NcActionButton), {
              "aria-label": _unref(t)('memories', 'Rotate Left'),
              title: _unref(t)('memories', 'Rotate Left'),
              disabled: __props.disabled,
              onClick: doleft
            }, {
              icon: _withCtx(() => [
                _createVNode(RotateLeftIcon, { size: 22 })
              ]),
              _: 1
            }, 8, ["aria-label", "title", "disabled"]),
            _createVNode(_unref(NcActionButton), {
              "aria-label": _unref(t)('memories', 'Rotate Right'),
              title: _unref(t)('memories', 'Rotate Right'),
              disabled: __props.disabled,
              onClick: doright
            }, {
              icon: _withCtx(() => [
                _createVNode(RotateRightIcon, { size: 22 })
              ]),
              _: 1
            }, 8, ["aria-label", "title", "disabled"]),
            _createVNode(_unref(NcActionButton), {
              "aria-label": _unref(t)('memories', 'Flip'),
              title: _unref(t)('memories', 'Flip'),
              disabled: __props.disabled,
              onClick: doflip
            }, {
              icon: _withCtx(() => [
                _createVNode(FlipHorizontalIcon, { size: 22 })
              ]),
              _: 1
            }, 8, ["aria-label", "title", "disabled"])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})